import { render, staticRenderFns } from "./pipProduct.vue?vue&type=template&id=a73d8792&scoped=true&"
import script from "./pipProduct.vue?vue&type=script&lang=js&"
export * from "./pipProduct.vue?vue&type=script&lang=js&"
import style0 from "./pipProduct.vue?vue&type=style&index=0&id=a73d8792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73d8792",
  null
  
)

export default component.exports